import { render, staticRenderFns } from "./ImgCardAgent.vue?vue&type=template&id=1a7c0032&scoped=true"
import script from "./ImgCardAgent.vue?vue&type=script&lang=js"
export * from "./ImgCardAgent.vue?vue&type=script&lang=js"
import style0 from "./ImgCardAgent.vue?vue&type=style&index=0&id=1a7c0032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7c0032",
  null
  
)

export default component.exports